import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";
import type { Step } from "../../types";
import { MarkCompleteButton } from "./MarkCompleteButton";
import { StepIcon } from "./StepIcon";

interface StepContentProps {
  step: Step;
}

export const StepContent = ({ step }: StepContentProps) => {
  const handleCtaClick = async () => {
    await step.customAction?.();
  };

  return (
    <div className="bg-secondary flex items-start gap-x-4 rounded-xl p-4">
      <div className="shrink-0 pt-1">
        <StepIcon status="incomplete" />
      </div>
      <div className="flex-1">
        <div className="mb-2">
          <Typography.LabelMd weight="semibold" color="text-dark">
            {step.title}
          </Typography.LabelMd>
        </div>
        <div className="mb-4">
          <Typography.BodySm color="text-default">
            {step.description}
          </Typography.BodySm>
        </div>
        <div className="flex items-center gap-3">
          <Button variant="circle" small onClick={handleCtaClick}>
            {step.cta}
          </Button>
          <MarkCompleteButton stepKey={step.key} />
        </div>
      </div>
    </div>
  );
};
